import React, { useState, useEffect } from 'react';
import DefaultLayout from '../../layouts/DefaultLayout';
import HeaderBG from '../../components/HeaderBG';
import SectionTitle from '../../components/SectionTitle';
import Drawer from './Drawer';
import { Container } from 'semantic-ui-react';
import Table from '../Certificados/Table';
import swal from 'sweetalert';
import feathers, { useAuth } from '../../services/feathers';
import Filters from './Filters';
import TopNavigation from './TopNavigation';


const Certificados = (props) => {
  const service = feathers.service('tax-certificados');
  const auth = useAuth();

  let [query, setQuery] = useState({Descripcion : {$like:'%%'}, Organizacion: auth.user.client._id});
  const [isBusy, setIsBusy] = useState(false);
  const [selection, setSelection] = useState([]);
  const [data, setData] = useState([]);
  const [isSupport, setIsSupport] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [openPanel, setOpenPanel] = useState(false);
  const [currentCertificado, setCurrentCertificado] = useState([]);
  const [certificado, setCertificado] = useState(null);
  

  useEffect(() => {
    const filter = () => {
      if(!query)
        query = {Descripcion : {$like:'%%'}, Organizacion: auth.user.client._id};
      getData();
    };

    filter();
  }, [query]);

  useEffect(() => {
    const { isSupport } = (auth && auth.user) || {},
      client = (auth && auth.user && auth.user.client) || null,
      isInvalid = (!isSupport && !client && true) || false;

    setIsSupport(isSupport);
    setCertificado(client);
    setIsValid(!isInvalid);
  }, [auth.user]);

  const handleCreateClick = () => {
    const [clients, client] = auth.user.isSupport
      ? [[], {}]
      : [[{ ...auth.user.client }], { ...auth.user.client }];
    openDrawer({ clients, client });
  };

  const openDrawer = (certificado) => {
    certificado.Organizacion = auth.user.client._id
    setCurrentCertificado(certificado);
    setOpenPanel(true);
  };
  const handleClose = (isSuccess) => {
    setCurrentCertificado({});
    setOpenPanel(false);

    isSuccess && getData();
  };
  const getData = async () => {
    
    if (query) {
      let data = [],
        result = [];

      try {
        setIsBusy(true);
        setSelection([]);

        // console.debug('query', JSON.stringify(query, null, 2));
        if(query.Organizacion != ''){
          do {
            result = await service.find({
              query: {
                ...query,
                $skip: data.length,
              },
            });
            data = data.concat(result.data);
          } while (data.length !== result.total);
        }
      } catch (err) {
        console.error('Error', err);
        data = [];
        swal({
          title: 'Error',
          text: 'Failed get Certificado',
          icon: 'error',
          buttons: {
            cancel: 'Close',
          },
        });
      } finally {
        setData(data);
        setIsBusy(false);
      }
    }
  };
  const handleEditClick = (trasporte) => {
    openDrawer(trasporte);
  };

  const handleDeleteClick = async (data) => {
    let confirmation = await swal('Do you want delete this item?', {
      buttons: ['No', 'Yes'],
    });

    if (confirmation) {
      try{
        await service.remove(data.idCertificado)
        swal('Borrado', '¡Se ha borrado correctamente!', 'success');
      }catch(exception){
        swal('Error', 'Dont delete Certificado', 'error');
      }
      getData();
    }
  };

  return (
     <>
      <DefaultLayout currentPath={props.match.path}
       globalActions={
           <TopNavigation
             isBusy={isBusy}
             onCreateClick={handleCreateClick}
             isValid={isValid}
           />
         }
      >
        <HeaderBG />
        <Container className="fluid-95">
          <SectionTitle>Catálogo Certificado</SectionTitle>
          <Filters
            isBusy={isBusy}
            setQuery={setQuery}
            isValid={isValid}
            getData = {getData}
          />
          <Table data={data}
            selection={selection}
            setSelection={setSelection}
            isSupport={isSupport}
            onEditClick={handleEditClick}
            onDeleteClick={handleDeleteClick}></Table>
        </Container>
      </DefaultLayout>
      {openPanel ? (
        <Drawer
          openPanel={openPanel}
          onClose={handleClose}
          currentCertificado={currentCertificado}
        ></Drawer>
      ) : null}
    </>
  );
  
};



export default Certificados;
